import type { Optional, StorageClient } from '../interfaces';

export class InMemoryStorage implements StorageClient {
  store: Record<string, string>;
  constructor() {
    this.store = {};
  }

  getItem(key: string): Optional<string> {
    return this.store[key];
  }

  setItem(key: string, value: string): void {
    this.store[key] = value;
  }

  removeItem(key: string): void {
    delete this.store[key];
  }

  flush() {
    this.store = {};
  }
}

export const inMemoryStorageClient: InMemoryStorage = new InMemoryStorage();
